import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const usersService = {
    getAllUsers,
    getUser,
    updateUser,
};

const MODULE = {
    USERS: 'users',
};

const API_URL = API.BASE_URL + '/v1';

export async function getAllUsers(filter) {
    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_active: filter.isActive,
            from: 'ONE_IT',
        }
    };

    if (filter?.group) requestOptions.params.group = filter?.group;
    
    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            requestOptions.params[searchParam] = word;
        }
    });
    return await apiHelper(API_URL).get(`/${MODULE.USERS}`, requestOptions);
}

export async function getUser(id) {
    return apiHelper(API_URL).get(`/${MODULE.USERS}/${id}`);
}

export async function updateUser(data) {
    const requestOptions = {
        name: data.name,
        email: data.email,
        role_uuid: data.roles,
        group_uuid: data.groups,
    };
    return apiHelper(API_URL).put(`/${MODULE.USERS}/${data.id}`, requestOptions);
}